import React, { useState } from 'react';
import { API, authFetch } from '../utils/api';
import { won } from './ClientScopeCombo';
import { useIsMobile } from '../utils/useMobile';
import { T } from '../v2/theme';
import { shareInviteLink } from '../utils/kakaoShare';

// 말소대행 거래처 앱 초대 링크 모달 (B4 W1) — 거래처 탭 미연결·활성 단위 ⋯ 메뉴 "앱 초대 링크 보내기".
//
// 열기만으로는 발급하지 않는다 — 서버가 발급 때 이전 미사용 링크를 즉시 만료시키므로(utils/malsoInvite.issue),
// [앱 초대 링크 보내기] 를 눌러야 POST /agency-clients/:id/invite 1회. 이미 보낸 링크를 확인하려고 다시 열어도
// 그 링크가 살아 있어야 한다 (앱 A1 rd_invite_sheet 와 같은 규칙). 발급 중 버튼 비활성 = 이중 POST 방지.
// 에러(400 UNIT_ALREADY_LINKED·UNIT_INACTIVE / 403 / 404)는 서버 문구 그대로 토스트 후 닫는다.
// [카톡으로 보내기] = 카카오 공유 카드(utils/kakaoShare.shareInviteLink, 버튼 '가입하기') — 글상자 문구는 문자·복사용이라 카드엔 안 실린다.
//   SDK 를 못 쓰면 링크 복사로 대신한다. sendDefault 는 클릭 핸들러에서 동기 호출(사파리 팝업 차단 — kakaoShare.js 머리말).
// 대행업체(broker 계정) 머리글 ⋯ 메뉴는 accountId 로 POST /billing-accounts/:id/invite — 본인 몫 단위로 같은 링크 (Jin 10/29).
// props: { unitId | accountId, unitName, qs ('?agencyId=…' | ''), showToast, onClose }

function pad2(n) { return (n < 10 ? '0' : '') + n; }

// 서버 expiresAt = UTC 'YYYY-MM-DD HH:MM:SS' (Z 없음) → 로컬 'YYYY-MM-DD HH:mm'
function localExpiry(s) {
  var d = new Date(String(s || '').replace(' ', 'T') + 'Z');
  if (isNaN(d.getTime())) return '';
  return d.getFullYear() + '-' + pad2(d.getMonth() + 1) + '-' + pad2(d.getDate()) + ' ' + pad2(d.getHours()) + ':' + pad2(d.getMinutes());
}

function CancelAgencyInviteModal(props) {
  var isMobile = useIsMobile();
  var showToast = props.showToast || function () {};
  var onClose = props.onClose || function () {};

  var [busy, setBusy] = useState(false);
  var [inv, setInv] = useState(null);   // 발급 응답 {url, expiresAt, balance, unitName, agencyName}
  var [msg, setMsg] = useState('');

  var issue = function () {
    if (busy) return;
    setBusy(true);
    var path = props.accountId ? '/billing-accounts/' + props.accountId : '/agency-clients/' + props.unitId;
    authFetch(API + path + '/invite' + (props.qs || ''), { method: 'POST' })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (!d || !d.success || !d.url) { showToast((d && d.error) || '초대 링크를 만들지 못했습니다', 'err'); onClose(); return; }
        setInv(d);
        setMsg('[' + (d.agencyName || '') + '] ' + (d.unitName || '') + ' 대표님, 앱으로 말소대행을 신청하실 수 있습니다. 아래 링크로 가입해 주세요.\n' + d.url);
      })
      .catch(function () { showToast('초대 링크를 만들지 못했습니다', 'err'); onClose(); });
  };

  var writeUrl = function () {
    var url = inv.url;
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).catch(function () { window.prompt('초대 링크를 복사하세요', url); });
    } else {
      window.prompt('초대 링크를 복사하세요', url);
    }
  };
  var copyLink = function () {
    writeUrl();
    showToast('링크를 복사했습니다');
  };

  var shareKakao = function () {
    var ok = shareInviteLink({
      url: inv.url, agencyName: inv.agencyName, unitName: inv.unitName,
      onError: function (m) { showToast('카카오 공유 실패: ' + m, 'err'); }
    });
    if (ok) return;
    writeUrl();
    showToast('링크를 복사했습니다 — 카카오톡에 붙여 넣어 보내 주세요');
  };

  var btnSt = isMobile ? { minHeight: 40, padding: '0 14px', fontSize: 13 } : undefined;
  var bal = inv ? (parseInt(inv.balance, 10) || 0) : 0;
  var exp = inv ? localExpiry(inv.expiresAt) : '';

  return (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999, padding: 16 }} onClick={onClose}>
      <div style={{ background: T.card, borderRadius: 14, padding: isMobile ? 16 : 20, width: 480, maxWidth: isMobile ? '94vw' : '100%', maxHeight: '90vh', overflowY: 'auto', boxShadow: '0 12px 40px rgba(0,0,0,0.18)' }} onClick={function (e) { e.stopPropagation(); }}>
        <h3 style={{ margin: '0 0 4px', fontSize: 15, color: T.navy }}>앱 초대</h3>
        <p style={{ fontSize: 12, color: T.muted, margin: '0 0 14px' }}>{props.unitName}</p>

        {!inv && (<React.Fragment>
          <p style={{ fontSize: 13, color: T.dim, margin: '0 0 14px', lineHeight: 1.6 }}>새 링크를 만들면 이전에 보낸 링크는 더 이상 쓸 수 없습니다.</p>
          <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
            <div style={{ flex: 1 }} />
            <button className="btn btn-outline btn-sm" style={btnSt} onClick={onClose}>닫기</button>
            <button className="btn btn-blue btn-sm" style={btnSt} disabled={busy} onClick={issue}>앱 초대 링크 보내기</button>
          </div>
        </React.Fragment>)}

        {inv && (<React.Fragment>
          <div style={{ background: T.accentTint, borderRadius: 10, padding: '10px 12px', fontSize: 13, fontWeight: 700, color: T.ink, marginBottom: 10 }}>
            이 거래처 현재 미수 {(bal < 0 ? '-' : '') + won(bal)} — 거래처 화면에 이전 잔액으로 표시됩니다
          </div>
          <textarea value={msg} onChange={function (e) { setMsg(e.target.value); }} rows={4}
            style={{ width: '100%', boxSizing: 'border-box', border: '1px solid ' + T.bd, borderRadius: 8, padding: 10, fontSize: 13, lineHeight: 1.6, fontFamily: 'inherit', resize: 'vertical' }} />
          <div style={{ fontSize: isMobile ? 12 : 11.5, color: T.faint, margin: '6px 0 14px' }}>
            7일 동안 유효 · 이 거래처 전용{exp ? ' (' + exp + '까지)' : ''}
          </div>
          <div style={Object.assign({ display: 'flex', gap: 8, alignItems: 'center' }, isMobile ? { flexWrap: 'wrap' } : null)}>
            <button className="btn btn-blue btn-sm" style={btnSt} onClick={copyLink}>링크 복사</button>
            <a className="btn btn-outline btn-sm" style={Object.assign({ textDecoration: 'none' }, btnSt)} href={'sms:?&body=' + encodeURIComponent(msg)}>문자로 보내기</a>
            <button className="btn btn-outline btn-sm" style={btnSt} onClick={shareKakao}>카톡으로 보내기</button>
            <div style={{ flex: 1 }} />
            <button className="btn btn-outline btn-sm" style={btnSt} onClick={onClose}>닫기</button>
          </div>
        </React.Fragment>)}
      </div>
    </div>
  );
}

export default CancelAgencyInviteModal;
